module.exports = __webpack_public_path__ + "img/nodeType6.08491210.svg";